module.exports = __webpack_public_path__ + "static/media/icn_mainnav_journeys_small.11c924e1.svg";